module.exports = __webpack_public_path__ + "static/media/ship.629f922c.svg";